import { render, staticRenderFns } from "./openpdf.vue?vue&type=template&id=53c256c8&scoped=true"
import script from "./openpdf.vue?vue&type=script&lang=js"
export * from "./openpdf.vue?vue&type=script&lang=js"
import style0 from "./openpdf.vue?vue&type=style&index=0&id=53c256c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c256c8",
  null
  
)

export default component.exports